import { Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import RequireAdmin from './auth/RequireAdmin.jsx';
import AdminLayout from './layout/AdminLayout.jsx';

import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Roles from './pages/Roles.jsx';
import Employees from './pages/Employees.jsx';
import Questionnaires from './pages/events/Questionnaires.jsx';
import Games from './pages/events/Games.jsx';
import Analytics from './pages/Analytics.jsx';
import Settings from './pages/Settings.jsx';
import Attendance from "./pages/Attendance.jsx";
import AnnouncementsPage from "./pages/AnnouncementsPage";
import MfaSetup from "./pages/MfaSetup.jsx";
import HrPoliciesPage from "./pages/hr/HrPoliciesPage.jsx";
import Documents from "./pages/hr/Documents.jsx";
import Assets from "./pages/hr/Assets.jsx";

const theme = createTheme({
  palette: {
    background: { default: '#f6f7fb' },
    primary: { main: '#3563E9' },
    success: { main: '#22C55E' },
    info: { main: '#7C3AED' }
  },
  shape: { borderRadius: 14 }
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/setup-mfa" element={<MfaSetup />} /> 
        <Route element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/events/questionnaires" element={<Questionnaires />} />
          <Route path="/events/games" element={<Games />} />
          <Route path="/hr/policies" element={<HrPoliciesPage />} />
          <Route path="/hr/documents" element={<Documents />} />
          <Route path="/hr/assets" element={<Assets />} />
          <Route path="/attendance" element={<Attendance />} />
          <Route path="/announcements" element={<AnnouncementsPage />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </ThemeProvider>
  );
}
